import { makeStyles, createStyles } from '@material-ui/core/styles';

const BrandingInRoomStyles = makeStyles((theme: any) => createStyles({
  
})
)

export { BrandingInRoomStyles };